import React from 'react';
import Page from 'src/components/Page';
import Logo from 'src/components/Logo';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Typography, Container } from '@material-ui/core';
import { PATH_APP } from 'src/routes/paths';

// ----------------------------------------------------------------------

class ErrorBoundaryGeneral extends React.Component {
  constructor(props) {
    super(props);

    this.state = { error: null, errorInfo: null, classes: null };
  }

  componentDidCatch(error, errorInfo, classes) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
      classes: classes
    });
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <Page
          title="500 Internal Server Error | TakeMyOrder"
          className={this.classes?.root}
        >
          <header className={this.classes?.header}>
            <Box onClick={() => window.location.reload()}>
              <Logo />
            </Box>
          </header>

          <Container maxWidth="xl">
            <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
              <Typography variant="h3" gutterBottom>
                500 Internal Server Error
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                Algo salió mal, por favor inténtelo de nuevo más tarde.
              </Typography>

              <Box
                component="img"
                alt="500"
                src="/static/illustrations/illustration_500.svg"
                sx={{ width: '100%', maxHeight: 240, my: { xs: 5, sm: 10 } }}
              />

              <Button
                type="button"
                onClick={() => window.location.reload()}
                size="large"
                variant="contained"
              >
                Volver al inicio
              </Button>
            </Box>
          </Container>
        </Page>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorBoundaryGeneral;
